export const environment = {
    production: true,
    firebase: {
        apiKey: 'AIzaSyBAwPcbpO2rRG55TD5GfRLPr4c_4Z2I-YI',
        authDomain: 'dev.ailotse.com',
        projectId: 'ailotse-dev',
        storageBucket: 'ailotse-dev.firebasestorage.app',
        messagingSenderId: '682344423748',
        appId: '1:682344423748:web:988b3d43f22e6943feb711',
        databaseURL: 'https://ailotse-dev-default-rtdb.europe-west1.firebasedatabase.app',
    },
    useAuthEmulator: false,
    useFunctionsEmulator: false,
    useFirestoreEmulator: false,
    useBucketEmulator: false,
    useDatabaseEmulator: false,
    tenantType: 'default',
    recaptchaSiteKey: '6LdytygrAAAAACA--AYc38SNgyBmy_aWEko-hHns',
    appCheckDebugToken: '',
    entraIdApplicationClientId: 'c166d979-4cb5-487f-ada1-2c60ca1a692a',
    scimApiUrl: 'https://dev.ailotse.com/api/v1/scim/?aadOptscim062020',
    helpUrl: 'https://help-dev.ailotse.com/de/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
